<!--Recherche-->
<div>
  <div class="search__container">
    <input
      type="text"
      #myInput
      [(ngModel)]="titre"
      (input)="SearchEventByTitre()"
      class="search__input"
      placeholder="Search …"
    />
    <input
      [hidden]="true"
      type="text"
      #myInput
      [(ngModel)]="date"
      (input)="SearchEventByDate()"
      class="search__input"
      placeholder="Search …"
    />
  </div>
</div>

<!--Filtre
  <div class="form-group">
    <input type="button" style="margin-bottom: 15px;" value="Filtre" class="filtre" />
    <select id="host" style="margin-bottom: 15px;">
      <option value="CLUB" selected>Club</option>
      <option value="UNIVERSITE">University</option>
      <option value="ADMINISTRATEUR" selected>Administrator</option>
      <option value="ETUDIANT">Student</option>
      <option value="ENSEIGNANT">Teacher</option>
    </select>
    <input type="date" style="margin-bottom: 15px;" #myInput [(ngModel)]="date" (input)="SearchEventByDate()" class="search-input" placeholder="Search …"/>
    <select id="lieu">
      <option value="Zaghouan" selected>Zaghouan</option>
      <option value="Manouba">Manouba</option>
      <option value="Tunis">Tunis</option>
      <option value="Sousse">Sousse</option>
      <option value="Nabeul">Nabeul</option>
      <option value="Sfax">Sfax</option>
    </select>
  </div>
  <br>-->
<br />

<!--ADD-->
<!--Add-->
<button
class="pulse"
style="margin-left: 43%"

(click)="openModal()"
>
Create Your Own Event
</button>
<div id="myModal" class="modal" style="display:none;" >
<div class="modal-dialog" style="width: 80%;">
  <div class="modal-content">
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">Add an event</h4>
    
     
      <button type="button" class="close" (click)="closeModal()">&times;</button>
    </div>
    
    <!-- Modal Body -->
    <div class="modal-body">
      <small>Note : Those informations will be public! </small><br><br>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="title">Title</label>
          <input type="text" formControlName="titre" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.titre.errors }" />
          <div *ngIf="submitted && f.titre.errors" class="invalid-feedback">
            <div *ngIf="f.titre.errors.required">title is required</div>
          </div>
        </div>
     
          <!--Date of event
            <div class="form-group">
            <label for="date">Date of event</label>
            <input type="date" formControlName="date" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" 
            (change)="validateDate()" />
            <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
              <div *ngIf="f.date.errors.required">date of event is required</div>
            </div>
          </div>
-->
          <!--Start time event date-->
          <div class="form-group">
            <label for="startime">Startime of event</label>
            <input type="datetime-local" formControlName="startime" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.startime.errors }" 
            (change)="validateDate()" />
            <div *ngIf="submitted && f.startime.errors" class="invalid-feedback">
              <div *ngIf="f.startime.errors.required">Start time of event is required</div>
            </div>
          </div>

            <!--End time event date  -->
            <div class="form-group">
              <label for="endtime">Endtime of event</label>
              <input type="datetime-local" formControlName="endtime" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.endtime.errors }" 
              (change)="validateDate()" />
              <div *ngIf="submitted && f.endtime.errors" class="invalid-feedback">
                <div *ngIf="f.endtime.errors.required">End Time of the event is required</div>
              </div>
            </div>
     
        
        <div class="form-group">
          <label for="description">Description</label>
          <textarea formControlName="description" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
          <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
            <div *ngIf="f.description.errors.required">Description is required</div>
          </div>
        </div>

        <div class="form-group">
          <label for="availablePlaces">Available places</label>
          <input type="number" formControlName="availablePlaces" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.availablePlaces.errors }">
          <div *ngIf="submitted && f.availablePlaces.errors" class="invalid-feedback">
            <div *ngIf="f.availablePlaces.errors.required">Available places is required</div>
          </div>
        </div>


        
          
        
        <!--Selection category of the event-->
        <div class="form-group">
          <label for="category">Category</label>
          <select formControlName="category" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.category.errors }">
            <option value="" disabled selected>Select category</option>
            <option value="Integration">Integration Event</option>
            <option value="Social">Social Event</option>
            <option value="Athletic">Athletic Event</option>
            <option value="Art and Culture">Art and Culture Event</option>
            <option value="Competitive">Competitive Event</option>
          </select>
          <div *ngIf="submitted && f.category.errors" class="invalid-feedback">
            <div *ngIf="f.category.errors.required">category is required</div>
          </div>
        </div>
        <!--Selection type of the event-->
        <div class="form-group">
          <label for="type">Type</label>
          <select formControlName="type" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.category.errors }">
            <option value="" disabled selected>Select Type</option>
            <option value="Physical">Physical Event</option>
            <option value="Virtual">Virtual Event</option>
            <option value="Hybrid">Hybrid Event</option>
          </select>
          <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
            <div *ngIf="f.type.errors.required">Type is required</div>
          </div>
        </div>
        <div *ngIf="f.type.value === 'Physical'">
          <!-- Physical fields... -->
          <div class="form-group">
            <label for="location">Location</label>
            <input type="text" formControlName="location" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.location.errors }" required />
            <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
              <div *ngIf="f.location.errors.required">Location is required</div>
            </div>
          </div>
        </div>
        
        <!-- Conditional fields for Service -->
        <div *ngIf="f.type.value === 'Virtual'">
          <!-- virtual fields... -->
          <div class="form-group">
            <label for="pricePerHour">Meeting Link</label>
            <input type="text" formControlName="zoomlink" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.zoomlink.errors }" required />
            <div *ngIf="submitted && f.zoomlink.errors" class="invalid-feedback">
              <div *ngIf="f.zoomlink.errors.required">Meeting link is required</div>
            </div>
          </div>
        </div>

        
           <!-- Conditional fields for Hybrid Event -->
           <div *ngIf="f.type.value === 'Hybrid'">
            <!-- Hybrid fields... -->
            <div class="form-group">
              <label for="location">Google maps link</label>
              <input type="text" formControlName="location" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.location.errors }" required />
              <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                <div *ngIf="f.location.errors.required">Google maps link is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="zoomlink">Event Meeting Link</label>
              <input type="text" formControlName="zoomlink" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.zoomlink.errors }" required />
              <div *ngIf="submitted && f.zoomlink.errors" class="invalid-feedback">
                <div *ngIf="f.zoomlink.errors.required">Event Meeting Link is required</div>
              </div>
            </div>
          </div>
        

        <div class="form-group">
          <label for="image">Image</label>
          <input type="file" formControlName="image" accept="image/*" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.image.errors }" (change)="onFileSelected($event)" />

          <div *ngIf="submitted && f.image.errors" class="invalid-feedback">
            <div *ngIf="f.image.errors.required">Image is required</div>
          </div>
        </div>
        
          
       
        
       
        <div class="form-group">
       <a href="/home/events"><button class="btn btn-outline-dark" type="submit">Add</button></a> 
        <a class="btn btn-link" type="reset" href="/home/events" (click)="closeModal()">Cancel</a>
        </div>
        
        </form>
        </div>
        </div>
        
          </div>
        </div>


<!--events-->
<div class="blog-slider5">
  <h4 style="text-align: center">Here Is {{ nEvents }} Events in Studenty</h4>
  <br />
  <br />
  <div class="container">
    <div class="row">
      <div *ngFor="let events of ListEvent; let i; of: index">
        <div class="main-card" style="width: 100%">
          <div class="cards">
            <div class="card" style="width: 336px; height: 355px">
              <div class="content">
                <li style="list-style-type: none">
                  <!-- <img src="http://localhost:9091/User/{{ posts.user.profileImage }}" style="width: 50px; height: 50px; border-radius: 50%; border: 2px solid #5A54FF; display: inline;" alt=""/>
                    <a class="nav-link" style="font-weight: bold; display: inline; color: black; ">
                      <i class="ion-md-power"></i> {{posts.user.nom}} {{posts.user.prenom}}
                    </a>-->
                  <a
                    (click)="openalert(contentalert); setEventId(events._id)"
                    [hidden]="hideSupp(events.user._id)"
                    [hidden]="hideUpp(events.user._id)"
                  >
                    <fa-icon
                      style="color: red"
                      [icon]="faTrash"
                      class="material-icons"
                    ></fa-icon>
                  </a>
                  <a
                    [hidden]="hideform"
                    (click)="topFunction()"
                    [routerLink]="['/updateevent', events._id]"
                    [hidden]="hideUpp(events.user._id)"
                    [hidden]="hideUpp(events.user._id)"
                  >
                    <fa-icon
                      style="color: blue"
                      [icon]="faPencilAlt"
                      class="material-icons"
                    ></fa-icon>
                  </a>
                  <br />

                  <!--<small>Published on : {{posts.date}}</small>-->
                </li>
                <div class="img" style="border: 2px red !important">
                  <img
                    src="http://localhost:9091/Event/{{ events.image }}"
                    style="width: 270px; height: 180px"
                    alt="Post Picture"
                  />
                </div>
                <div class="details">
                  <div class="name" style="hyphens: none; color: #1b2559; margin-bottom: -5px; font-size: 24px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ events.titre }}
                  </div>
                </div>
                
                

                <p style="width: 80%; height: 70px; color: #a3aed0; margin-bottom: 27px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ events.description | slice:0:100 }}{{ events.description.length > 100 ? '...' : '' }}
                </p>
                
                

                <a style="color: black; margin-left: 65%; margin-top: -130px">
                  <p style="color: black">
                    <span style="margin-right: 20px">{{ events.like }}</span>
                    <a
                      style="font-size: large; margin-top: -6.3%"
                      (click)="likeEvent(events._id)"
                      href="/home/events"
                    >
                      <i
                        class="fa-sharp fa-solid fa-heart"
                        style="color: #000000; margin-left: -20.3%"
                      ></i>
                    </a>
                    <span style="margin-right: -10px">{{
                      events.nombreCommentaire
                    }}</span>
                    <i
                      class="fa-solid fa-comment fa-lg"
                      style="color: #000000; float: right"
                    ></i>
                  </p>
                </a>

                <!--
                  <a style=" font-size: large; margin-left: -80%;margin-top: -18%;" (click)="likePost(posts._id)"  href="/home/posts">
                    <i class="fa-sharp fa-solid fa-heart fa-beat-fade" style="color: #000000;"></i>
                  </a>
                 <a style=" font-size: large; margin-left: -65%; margin-top: -6.3%; " (click)="dislikePost(posts._id)"  href="/home/posts">
                    <fa-icon style="color: #5A54FF;" [icon]="faThumbsDown"  class="material-icons"></fa-icon>
                  </a>-->

                <br />
                <div style="margin-left: 65px; margin-top: 15px">
                  <button
                    class="custom-button"
                    (click)="setEventId(events._id)"
                    [routerLink]="'/home/events/event'"
                  >
                    See More
                  </button>
                </div>

                <br />
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Delete-->
<ng-template #contentalert let-modal>
  <div class="modal-header">
    <h5
      style="color: black; text-align: center"
      class="modal-title"
      id="modal-basic-title"
    >
      Are You Sur to delete this event ?
    </h5>
    <a href="/home/events">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </a>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group" style="align-items: center">
        <a
          style="color: red"
          href="/home/events"
          class="btn btn-default"
          (click)="deleteEvent(); modal.dismiss('Cross click')"
          >Confirm</a
        >
        <a
          style="color: green"
          class="btn btn-link"
          class="btn btn-default"
          href="/home/events"
          (click)="modal.dismiss('Cross click')"
          >Cancel</a
        >
      </div>
    </form>
  </div>
</ng-template>